import React from 'react';
import { Box, Divider, Pagination, Typography } from '@mui/material';

const styles = {
  card: {
    bgcolor: 'background.paper',
    borderRadius: 3,
    px: 2,
    pt: 1,
    pb: 1.25,
    overflow: 'hidden',
  },
  title: {
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    fontSize: '0.65rem',
    fontWeight: 700,
    display: 'block',
    pt: 1,
    pb: 1,
    color: 'text.disabled',
  },
  header: {
    display: 'grid',
    gap: 1,
    px: 1,
    pb: 0.75,
  },
  headerCell: {
    fontSize: '0.65rem',
    fontWeight: 700,
    color: 'text.disabled',
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
  },
  row: {
    display: 'grid',
    gap: 1,
    alignItems: 'center',
    px: 1,
    py: 1,
  },
  cell: {
    fontSize: '0.75rem',
    color: 'text.primary',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    pt: 1.25,
  },
};

export default function DetailDataTable({ title, columns, rows, gridTemplateColumns, page, pageCount, onPageChange, getRowKey }) {
  return (
    <Box sx={styles.card}>
      {title ? (
        <Typography variant="caption" sx={styles.title}>
          {title}
        </Typography>
      ) : null}

      <Box sx={{ ...styles.header, gridTemplateColumns }}>
        {columns.map(column => (
          <Typography key={column.key} sx={styles.headerCell}>
            {column.label}
          </Typography>
        ))}
      </Box>

      {rows.map((row, index) => (
        <React.Fragment key={getRowKey(row, index)}>
          {index > 0 && <Box sx={{ mx: 1 }}><Divider /></Box>}
          <Box sx={{ ...styles.row, gridTemplateColumns }}>
            {columns.map(column => (
              <Typography key={column.key} sx={styles.cell}>
                {column.render ? column.render(row) : row[column.key] ?? '-'}
              </Typography>
            ))}
          </Box>
        </React.Fragment>
      ))}

      {pageCount > 1 ? (
        <Box sx={styles.pagination}>
          <Pagination
            count={pageCount}
            page={page}
            onChange={(_, value) => onPageChange(value)}
            size="small"
            color="primary"
          />
        </Box>
      ) : null}
    </Box>
  );
}
